import { Injectable } from '@angular/core';
import { Product } from '@interfaces/interfaces';
import { loadingProduct } from '@mockup_data/skeleton_data';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProductListService {
  //TODO regroup all product function here.
  // like add, edit, delete, etc...
  private productSource = new BehaviorSubject(loadingProduct);
  currentProduct = this.productSource.asObservable();

  constructor() {}

  changeProduct(product: Product) {
    this.productSource.next(product);
  }

  getCurrentProduct(): Product {
    return this.productSource.getValue();
  }

  saveProduct(product: Product) {
    // this.productSource.next(product);
  }
}
